import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { useEnquiry } from "@/context/EnquiryContext";

export default function CtaBanner({ title, subtitle, image }) {
  const { openEnquiry } = useEnquiry();
  return (
    <section id="cta" data-testid="home-cta" className="relative py-28 sm:py-40 overflow-hidden">
      <img src={image || "https://images.pexels.com/photos/16497359/pexels-photo-16497359.jpeg?auto=compress&cs=tinysrgb&w=1600"} alt="India" className="absolute inset-0 w-full h-full object-cover" />
      <div className="absolute inset-0 bg-gradient-to-r from-[#2d1616]/90 via-[#2d1616]/70 to-[#14523d]/60" />
      <div className="absolute inset-0 paper-grain opacity-20" />
      <div className="relative max-w-[1400px] mx-auto px-5 sm:px-8 text-center">
        <motion.div initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.8 }}>
          <div className="flex items-center justify-center gap-3 mb-6">
            <span className="h-px w-10 bg-[#d4af37]" />
            <span className="text-[11px] tracking-[0.34em] uppercase text-[#e8c970] font-semibold">Begin Your Journey</span>
            <span className="h-px w-10 bg-[#d4af37]" />
          </div>
          <h2 className="font-serif text-white text-4xl sm:text-6xl lg:text-7xl leading-[1.02] tracking-tight max-w-4xl mx-auto">
            {title || "Ready to Discover India?"}
          </h2>
          <p className="text-white/80 text-lg mt-6 max-w-2xl mx-auto leading-relaxed">{subtitle}</p>
          <button onClick={() => openEnquiry()} data-testid="cta-plan-trip" className="group mt-10 inline-flex items-center gap-3 bg-[#d4af37] hover:bg-[#e8c970] text-[#2d1616] px-10 py-5 text-xs tracking-[0.28em] uppercase font-semibold transition-colors">
            Plan My Trip <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
          </button>
        </motion.div>
      </div>
    </section>
  );
}
